import { documentationActions } from '../../actions/constant';
const { SET_NAVIGATION_FORM, RESET_NAVIGATION_FORM } = documentationActions;

const intitialstate: object = {
  navigateTo: null,
};

export const preventNavigationReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SET_NAVIGATION_FORM:
      return {
        ...state,
        navigateTo: action.payload,
      };

    case RESET_NAVIGATION_FORM:
      return intitialstate;

    default:
      return state;
  }
};
